<template>
  <div class="relative pt-8">
    <!-- <PopupWhoWeAre
      :isActive="isDetailsActive"
      :selectedWhoWeAre="selectedWhoWeAre"
      @close="toggleDetails"
    /> -->
    <!-- <div class="absolute bg-design6 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd6.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <div class="absolute bg-design7">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:py-0 md:py-0 py-4 w-full mx-auto">
      <div class="flex items-center justify-between gap-4">
        <p class="title md:font-normal lg:font-normal font-bold sm-fsize20">
          All Products
        </p>
        <!-- <el-select filterable placeholder="Service Provider" class="">
          <el-option disabled="true">Select Channel...</el-option>
          <el-option>Private Channel</el-option>
          <el-option>Public Channel</el-option>
        </el-select> -->
      </div>

      <!-- //////<div class="bg-white">
        <div
          class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-8 md:gap-8 gap-4"
        >
          <div
            class="flip-card1 relative rounded-xl lg:mt-0 md:mt-8 mt-4 lg:mb-0 md:mb-0 mb-4 cursor-pointer shadow-lg bg-white"
            @click="toggleDetails(true, item)"
            v-for="item in tableData"
            :key="item._id"
          >
            <div class="">
              <div class="flip-card1-inner">
                <div class="flip-card1-front">
                  <div class="py-4">
                    <img
                      :src="`${$imageURL}/${item.productImage}`"
                      :alt="item.name"
                      class="frameht"
                    />
                  </div>
                  <div class="w-full lg:px-8 text-center">
                    <p
                      class="lg:text-xl md:text-xl sm-fsize14 line-clamp2 text-black font-semibold pb-1 cursor-pointer"
                    >
                      {{ item.name }}
                    </p>
                    <p
                      class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
                    >
                      &#8377;{{ item.price }}
                    </p>
                  </div>
                </div>
                <div
                  class="flip-card1-back flex text-center justify-center pl-3"
                >
                  <div class="text-left">
                    <h2
                      class="lg:text-xl md:text-lg sm-fsize14 text-black font-semibold py-2 cursor-pointer"
                    >
                      {{ item.name }}
                    </h2>

                    <div>
                      {{ item.description }}////// -->
      <!-- <p class="sm-fsize14">Undereye serum by ethiko.</p>
                      <p class="sm-fsize14">
                        Made with coffee-infused jojoba oil, rosehip oil and
                        olive squalane, Ethiko's Undereye Serum is highly
                        effective in:
                      </p>
                      <p class="sm-fsize14">- Reducing dark circles</p>
                      <p class="sm-fsize14">- Soothing puffy eyes</p>
                      <p class="sm-fsize14">
                        - Smoothening fine lines and crow's feet around the eye
                        area
                      </p> -->
      <!--////// </div> //////-->
      <!-- //////<div v-if="item.id === '02'">
                      <p class="sm-fsize14">
                        Delay signs of aging like fine lines, dark spots, and
                        blemishes with Ethiko's Age Defying Serum, which is the
                        perfect anti-aging solution.
                      </p>
                      <p class="sm-fsize14">
                        - Reducing fine lines and wrinkles
                      </p>
                      <p class="sm-fsize14">
                        - Fading blemishes and dark spots
                      </p>
                      <p class="sm-fsize14">
                        - Giving a new life to dry and dull skin
                      </p>
                    </div>
                    <div v-if="item.id === '03'">
                      <p class="sm-fsize14">
                        Celebrate the caregiving journey and the caregiver. Gift
                        this cute hamper to a loved one or buy it for yourself
                        to show some self-love. This hamper is a combination of
                        a happiness journal, a calendar, and a glass candle,
                        printed with pretty florals.
                      </p>
                    </div> -->
      <!-- ////// </div>
                </div>
              </div>
            </div>

            <a :href="item.url" target="_blank">
              <base-button
                type="primary"
                class="lg:py-2 md:py-2 w-full flex m-auto py-1 px-8 fsize20 sm-fsize14 border-2 mt-0 whitespacenowrap absolute bottom-0"
                >Buy Now
              </base-button>
            </a> -->
      <!-- ////// <div
              class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 lg:mt-0 md:mt-8 mt-4 cursor-pointer shadow-lg bg-white"
            >
              <div class="relative h-336">
                <div class="w-full py-4">
                  <img
                    src="@/assets/images/allproducts/2.jpg"
                    alt=""
                    class="frameht"
                  />
                </div>
                <div class="w-full lg:px-8 text-center">
                  <p
                    class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
                  >
                    Gifts Of Love - Dear Zindagi
                  </p>
                  <p
                    class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
                  >
                    &#8377;800/-
                  </p>
                </div>
                <a href="/ecommerce">
                  <div
                    class="absolute top-0 left-0 blur1 w-full flex justify-center items-center h-380 sm-h290px"
                  >
                    <p class="fsize20">View All</p>
                  </div>
                </a>
              </div>
            </div> -->
      <!-- ////// </div>
          <div
            class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 lg:mt-0 md:mt-8 mt-4 cursor-pointer shadow-lg bg-white"
          >
            <div class="relative h-336">
              <div class="w-full py-4">
                <img
                  :src="`${$imageURL}/${lastData.productImage}`"
                  :alt="lastData.name"
                  class="frameht"
                />
              </div>
              <div class="w-full lg:px-8 text-center">
                <p
                  class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
                >
                  {{ lastData.name }}
                </p>
                <p
                  class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
                >
                  &#8377;{{ lastData.price }}/-
                </p>
              </div>
              <a href="/ecommerce">
                <div
                  class="absolute top-0 left-0 blur1 w-full flex justify-center items-center h-380 sm-h290px"
                >
                  <p class="fsize20">View All</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div> //////-->

      <div class="bg-white mt-8">
        <div
          class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-6 md:gap-6 gap-4"
        >
          <div
            :class="{
              custopacity: item.isURL == false && item.sku < 1,
            }"
            class="flip-card1 relative rounded-xl lg:mb-12 md:mb-12 mb-4 cursor-pointer shadow-lg bg-white mt-2"
            @click="toggleDetails(true, item)"
            v-for="item in tableData"
            :key="item._id"
          >
            <div class="">
              <div class="flip-card1-inner">
                <div class="flip-card1-front">
                  <div class="">
                    <img
                      v-if="item.productImage"
                      :src="`${$imageURL}/${item.productImage}`"
                      :alt="item.name"
                      class="h-280px sm-h-210 rounded-t-lg w-full object-contain"
                    />
                    <img
                      v-else
                      :src="$noIMG"
                      :alt="item.name"
                      class="frameht w-full rounded-t-lg"
                    />
                  </div>
                  <div class="w-full lg:px-8 py-3 text-center">
                    <p
                      class="lg:text-lg md:text-lg sm-fsize16 line-clamp2 text-black font-semibold pb-1 cursor-pointer"
                    >
                      {{ item.name }}
                    </p>
                    <span
                      class="fsize18 sm-fsize12 font-normal lh32px sm-lineh21 cursor-pointer"
                    >
                      &#8377;{{ item.price }} </span
                    ><br />
                    <template v-if="item.isURL == false">
                      <span
                        class="fsize16 sm-fsize12 font-normal lh32px sm-lineh21 cursor-pointer"
                        v-if="
                          Object.keys(user).length !== 0 ||
                          item.membershipDisc[membershipName] !== ''
                        "
                      >
                        <template
                          v-if="parseInt(item.membershipDisc[membershipName])"
                        >
                          Get an additional discount of
                          {{ item.membershipDisc[membershipName] }}% on your
                          {{ membershipName }} plan
                        </template>
                      </span>
                    </template>
                  </div>
                </div>
                <div class="flip-card1-back flex text-center justify-center">
                  <div class="text-left px-3 pt-2">
                    <h2
                      class="lg:text-lg lineclamp-2 md:text-lg sm-fsize18 text-black font-semibold cursor-pointer"
                    >
                      {{ item.name }}
                    </h2>

                    <div class="pt-2">
                      <p class="ellipsis-12 fsize15">
                        {{ item.description }}
                      </p>
                      <!-- <p class="sm-fsize14">Undereye serum by ethiko.</p>
                      <p class="sm-fsize14">
                        Made with coffee-infused jojoba oil, rosehip oil and
                        olive squalane, Ethiko's Undereye Serum is highly
                        effective in:
                      </p>
                      <p class="sm-fsize14">- Reducing dark circles</p>
                      <p class="sm-fsize14">- Soothing puffy eyes</p>
                      <p class="sm-fsize14">
                        - Smoothening fine lines and crow's feet around the eye
                        area
                      </p> -->
                    </div>
                    <!-- <div v-if="item.id === '02'">
                      <p class="sm-fsize14">
                        Delay signs of aging like fine lines, dark spots, and
                        blemishes with Ethiko's Age Defying Serum, which is the
                        perfect anti-aging solution.
                      </p>
                      <p class="sm-fsize14">
                        - Reducing fine lines and wrinkles
                      </p>
                      <p class="sm-fsize14">
                        - Fading blemishes and dark spots
                      </p>
                      <p class="sm-fsize14">
                        - Giving a new life to dry and dull skin
                      </p>
                    </div>
                    <div v-if="item.id === '03'">
                      <p class="sm-fsize14">
                        Celebrate the caregiving journey and the caregiver. Gift
                        this cute hamper to a loved one or buy it for yourself
                        to show some self-love. This hamper is a combination of
                        a happiness journal, a calendar, and a glass candle,
                        printed with pretty florals.
                      </p>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.isURL == false">
              <div v-if="item.sku >= 1" class="">
                <div class="w-full absolute bottom-0 p-3">
                  <base-button
                    @click="addToCart(item._id)"
                    type="primary"
                    class="lg:py-2 md:py-2 py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                    >Add to Cart
                  </base-button>
                </div>
              </div>
              <div v-else>
                <div class="w-full absolute bottom-0 p-3">
                  <base-button
                    type="primary"
                    class="lg:py-2 custoutstock md:py-2 bg- py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                    >Out of Stock
                  </base-button>
                </div>
              </div>
            </div>
            <div v-else>
              <a :href="item.url" target="_blank">
                <div class="w-full absolute bottom-0 p-3">
                  <base-button
                    type="primary"
                    class="lg:py-2 md:py-2 py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                    >Buy Now
                  </base-button>
                </div>
              </a>
            </div>

            <!-- <div
              class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 lg:mt-0 md:mt-8 mt-4 cursor-pointer shadow-lg bg-white"
            >
              <div class="relative h-336">
                <div class="w-full py-4">
                  <img
                    src="@/assets/images/allproducts/2.jpg"
                    alt=""
                    class="frameht"
                  />
                </div>
                <div class="w-full lg:px-8 text-center">
                  <p
                    class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
                  >
                    Gifts Of Love - Dear Zindagi
                  </p>
                  <p
                    class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
                  >
                    &#8377;800/-
                  </p>
                </div>
                <a href="/ecommerce">
                  <div
                    class="absolute top-0 left-0 blur1 w-full flex justify-center items-center h-380 sm-h290px"
                  >
                    <p class="fsize20">View All</p>
                  </div>
                </a>
              </div>
            </div> -->
          </div>
          <div
            class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 lg:mt-0 md:mt-8 mt-4 cursor-pointer shadow-lg bg-white h-380"
          >
            <!-- <div
            class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 lg:mt-0 md:mt-8 mt-4 cursor-pointer shadow-lg bg-white h-380"
            @click="handleClick('ecommerce')"
          > -->
            <div class="relative h-336">
              <div class="w-full py-4">
                <img
                  :src="`${$imageURL}/${lastData.productImage}`"
                  :alt="lastData.name"
                  class="frameht"
                />
              </div>
              <div class="w-full lg:px-8 text-center">
                <p
                  class="lg:text-xl md:text-xl ellipsis-6 sm-fsize16 text-black font-semibold pb-2 cursor-pointer"
                >
                  {{ lastData.name.slice(0, 40) }}...
                </p>
                <p
                  class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
                >
                  &#8377;{{ lastData.price }}/-
                </p>
              </div>
              <a href="/ecommerce">
                <!-- <a> -->
                <div
                  class="absolute top-0 left-0 blur1 w-full flex justify-center items-center h-380 sm-h290px"
                >
                  <p class="fsize20">View All</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="lg:py-12 md:py-12 lg:px-5 md:px-5 w-full">
      <p class="title md:font-normal lg:font-normal font-bold sm-fsize16">
        All Products
      </p>

      <div
        class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-2 lg:gap-8 md:gap-8 gap-4"
      >
        <div
          class="rounded-xl lg:mb-0 md:mb-0 mb-4 cursor-pointer shadow-lg bg-white"
          @click="toggleDetails(true, item)"
          v-for="(item, index) in cards"
          :key="index"
        >
          <div class="w-full py-4">
            <img :src="item.img" alt="" class="frameht" />
          </div>
          <div class="w-full lg:px-8">
            <p
              class="lg:text-xl text-center md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
            >
              {{ item.title }}
            </p>
            <p
              class="lg:text-lg text-center md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
            >
              {{ item.price }}
            </p>

            <a :href="item.link" target="_blank">
              <div class="pt-12 w-full">
                <base-button
                  type="primary"
                  class="py-2 px-8 fsize20 sm-fsize16 border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto absolute bottom-0"
                  >{{ item.button }}
                </base-button>
              </div>
            </a>
          </div>
        </div>
        <div
          class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 cursor-pointer shadow-lg bg-white"
        >
          <div class="relative h-336">
            <div class="w-full py-4">
              <img
                src="@/assets/images/allproducts/2.jpg"
                alt=""
                class="frameht"
              />
            </div>
            <div class="w-full lg:px-8 text-center">
              <p
                class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
              >
                Gifts Of Love - Dear Zindagi
              </p>
              <p
                class="lg:text-lg md:text-lg sm-fsize14 pt-1 font-normal lh32px sm-lineh21 cursor-pointer"
              >
                &#8377;800/-
              </p>
            </div>
            <a href="/ecommerce">
              <div
                class="absolute top-0 left-0 blur1 w-full flex justify-center items-center h-380"
              >
                <p class="fsize20">View All</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import PopupWhoWeAre from "./PopupWhoWeAre.vue";
import { mapState } from "vuex";
import RightBottomVue from "../../profile/components/RightBottom.vue";
export default {
  components: {
    // PopupWhoWeAre,
  },
  data() {
    return {
      selectedWhoWeAre: {},
      isDetailsActive: false,
      totalRows: 0,
      perPage: 3,
      currentPage: 1,
      lastData: {},
      tableData: [],
      membershipName: "",
      cards: [
        // {
        //   id: "01",
        //   img: require("@/assets/images/allproducts/7.jpg"),
        //   title: "Under-Eye Serum - 5ml",
        //   price: "999/-",
        //   button: "Buy Now",
        //   link: "https://caregiversaathi.myinstamojo.com/product/3691183/undereye-serum-5ml-e85e6",
        //   desc: "",
        // },
        // {
        //   id: "02",
        //   img: require("@/assets/images/allproducts/8.jpg"),
        //   title: "Age Defying Serum - 5ml",
        //   price: "999/-",
        //   button: "Buy Now",
        //   link: "https://caregiversaathi.myinstamojo.com/product/3691185/age-defying-serum-5ml",
        //   desc: "",
        // },
        // {
        //   id: "03",
        //   img: require("@/assets/images/allproducts/1.jpg"),
        //   title: "Gifts Of Love - Key to Happiness",
        //   price: "800/-",
        //   button: "Buy Now",
        //   link: "https://caregiversaathi.myinstamojo.com/product/3691156/gifts-of-love-key-to-happiness",
        //   desc: "",
        // },
      ],
    };
  },
  computed: {
    ...mapState("affiliate", {
      products: "products",
      cartData: "cartData",
    }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  methods: {
    handleProduct() {
      window.open("");
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedWhoWeAre = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });

      // this.toggleNavbar();
    },
    async getAllProduct() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
        isAdminRequest: "false",
      };

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const allProduct = await this.$store.dispatch(
          "affiliate/getAllProduct",
          payload
        );

        // console.log(allProduct);
        loader.close();

        this.totalRows = this.products.totalCount;
        let data = this.products.result.map((d) => d);
        this.lastData = data.pop();
        this.tableData = data;
        // console.log(this.products);
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    async addToCart(id) {
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        return;
        this.$swal
          .fire({
            title: "Login",
            text: "Please Login to continue viewing the blog",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showConfirmButton: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: "signin" });
            }
          });
      }
      try {
        // await this.$store.dispatch("affiliate/getCart");
        // let flag = false;
        // this.cartData.data.result[0].productId.forEach((e) => {
        //   if (e._id == id) {
        //     flag = true;
        //   }
        // });
        // if (flag) {
        //   this.$swal.fire({
        //     // title: "Session Expired",
        //     text: "Product already added to cart!",
        //     icon: "info",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   });
        //   return;
        // }
        // console.log("Outer Foreach");

        let data = await this.$store.dispatch("affiliate/addItem", {
          productId: id,
        });
        if (data.code == 200) {
          this.$notify({
            title: "Added",
            message: "Product added to cart!!",
            type: "success",
            duration: "1500",
            // icon: "success",
            // confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            // confirmButtonText: "Okay",
            // right,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.data.message.includes("Product not available")) {
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
        }
      }
    },
  },
  async mounted() {
    await this.getAllProduct();
    if (
      this.getUserByUserId.hasOwnProperty("currentMembership") &&
      this.getUserByUserId.currentMembership != null
    ) {
      this.membershipName = this.getUserByUserId.currentMembership.name;
    }
  },
};
</script>
<style>
.h-380 {
  height: 450px;
}

.line-clamp2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.flip-card1 {
  background-color: transparent;
  width: 100%;
  height: 450px;
  perspective: 1000px;
}

.flip-card1-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.flip-card1:hover .flip-card1-inner {
  transform: rotateY(180deg);
}

.flip-card1-front,
.flip-card1-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card1-front {
  color: black;
}

.flip-card1-back {
  background-color: #eee2ff;
  color: black;
  transform: rotateY(180deg);
  height: 450px;
  border-radius: 10px;
}

@media (max-width: 640px) {
  .sm-h290px {
    height: 400px;
  }
  .flip-card1 {
    width: auto !important;
    height: 400px !important;
  }
  .flip-card1-back {
    height: 400px !important;
  }
}
</style>
